<template>

</template>

<script>
import DiemDenAnToanApi from '../../../moduleApi/DiemDenAnToanApi';
import MethodService from '../../../service/MethodService';

export default {
  name: 'DanhGiaDDATHangNgay',
  methods: {
    async ridirectToForm() {
      let currentUser = MethodService.getCurrentUser();

      let dataFilter = {
        filters: "nguoi_tao_id:in:" + currentUser.id,
      };

      let ddat = await DiemDenAnToanApi.list(dataFilter);
      if (ddat.result.length > 0) {
        this.$router.push({
          name: "Admin-DangKyDDAT-daily",
          params: { id: ddat.result[0].id },
        });
      }
    }
  },
  mounted() {
    this.ridirectToForm();
  }
}
</script>
